<template>
  <div id="app" class="app" :style="{ height: scrollerHeight }">
    <div class="nav">
      <div class="logo" @click="clickLogo">
        <img src="./assets/logo.png" />
      </div>
      <div v-if="active === 'reth'" class="nav-right">
        <template v-if="ethAccount == ''">
          <span class="connect-metamask" @click="connectMetamask()">{{$t("home.connect-metamask")}}</span>
        </template>
        <template v-else>
          <span class="balance">{{ ethBalance }} ETH</span> <span class="address">{{ ethAddress }}</span>
        </template>
      </div>
      <div v-if="active === 'rfis'" class="nav-right">
        <template v-if="fisAccount == ''">
          <span class="connect-metamask" @click="connectPolkadotjs()">{{$t("home.connect-polkadotjs")}}</span>
        </template>
        <template v-else>
          <span class="balance">{{ fisBalance }} FIS</span> <span class="address" @click="jumpToFisAccountList">{{ fisAddress }}</span>
        </template>
      </div>
      <div v-if="active === 'rbridge'" class="nav-right">
        <template v-if="showAccountStatus==1">
          <span class="balance">{{ ethBalance }} ETH</span> <span class="address">{{ ethAddress }}</span>
        </template>
        <template v-if="showAccountStatus==2">
          <span class="balance">{{ fisBalance }} FIS</span> <span class="address" @click="jumpToFisAccountList">{{ fisAddress }}</span>
        </template>
      </div>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="menus">

           <div class="menu" :class="{'active': active === 'reth'}" @click="selectElement('reth')">   
            <div class="icon">
              <img src="./assets/eth.png" />
            </div>
            <div class="text">
              rETH
            </div>
          </div>
          
          <div class="menu" :class="{'active': active === 'rfis'}" @click="selectElement('rfis')">
            <div class="icon">
              <img src="./assets/fis.png" />
            </div>
            <div class="text">
              rFIS
            </div>
          </div>

          <div class="menu" :class="{'active': active === 'rbridge'}" @click="selectElement('rbridge')">
            <div class="icon">
              <img src="./assets/rbridge.png" />
            </div>
            <div class="text">
              rBridge
            </div>
          </div>

        </div>

        <div class="env">
          <div class="point"></div>
          <div class="text">{{ envText }}</div>
        </div>
      </div>
      <router-view 
        @connectMetamask="connectMetamask" 
        @refreshEthBalance="refreshEthBalance"
        @handleFisAccount="handleFisAccount"
        @connectPolkadotjs="connectPolkadotjs"
        @refreshFisBalance="refreshFisBalance"
        @showAccount="showAccount" >
      </router-view>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import Web3Utils from 'web3-utils';
import config from './config/env';
import NumberUtil from './util/numberUtil.js';
import StringUtil from './util/stringUtil.js';
import LocalStorage from './util/localStorage.js';
import {
  web3Accounts,
  web3Enable,
  web3FromSource,
  web3FromAddress,
  web3ListRpcProviders,
  web3UseRpcProvider
} from '@polkadot/extension-dapp';
import Api from './util/SubstrateApi.js';

const defaultActive = 'reth';

export default {
  name: 'app',

  data() {
    let active = defaultActive;

    const routeName = this.$route.name;
    if (routeName) {
      if (routeName.indexOf('fis') != -1) {
        active = 'rfis';
      } else if (routeName.indexOf('bridge') != -1) {
        active = 'rbridge';
      } else if (routeName.indexOf('eth') == -1 && routeName != 'home') {
        this.$router.push('/reth');
      }
    }
    let envText = 'Mainnet';
    if (config.env == 'dev') {
      envText = 'Testnet';
    }
    return {
      envText: envText,
      scrollerHeight: '750px',
      active: active,
      showAccountStatus: 0,
      ethAccount: '',
      ethBalance: '--',
      ethAddress: '',
      fisAccount: '',
      fisBalance: '--',
      fisAddress: ''
    };
  },

  mounted() {
    // MetaMask Listener
    if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
      ethereum.autoRefreshOnNetworkChange = false;
      ethereum.on('accountsChanged', (accounts) => {
        this.ethAccount = accounts[0];
        this.handleEthAccount(this.ethAccount);
      })
    }
  },

  methods: {
    selectElement(name) {
      const routeName = this.$route.name;
      if (name == routeName) {
        return;
      }
      window.scrollTo(0, 0); 
      this.active = name;
      if (name == 'reth') {
        if (!this.ethAccount) {
          this.$router.push('/');
        } else {
          this.$router.push('/' + name);
        }
      } else if (name == 'rfis') {
        if (LocalStorage.getCurrentFisAccount()) {
          this.handleFisAccount();
          this.$router.push('/' + name);
        } else {
          this.$router.push('/fishome');
        } 
      } else if (name == 'rbridge') {
        this.$router.push('/rbridge');
      }
    },
    clickLogo() {
      this.active = defaultActive;
      if (this.$router && this.$router.currentRoute &&
       this.$router.currentRoute.name != 'home') {
        this.$router.push('/');
      }
      location.reload();
    },
    showAccount(status) {
      this.showAccountStatus = status;
      if (this.showAccountStatus == 1) {
        this.refreshEthBalance();
      } else if (this.showAccountStatus == 2) {
        this.refreshFisBalance();
      }
    },
    connectMetamask() {
      if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
        //Will Start the metamask extension
        ethereum.request({ method: 'eth_requestAccounts' }).then(accounts => {
          this.ethAccount = accounts[0];
          this.handleEthAccount(this.ethAccount);
        })
        .catch((error) => {
          if (error.code === 4001) {
            Toast({ 
              message: 'Please connect to MetaMask.', 
              duration: 3000 
            });
          } else {
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          }
        }); 
      } else {
        Toast({ 
          message: 'Please install MetaMask!', 
          duration: 3000 
        });
      }
    },

    refreshEthBalance() {
      if (ethereum.selectedAddress) {
        this.ethAccount = ethereum.selectedAddress;
        this.handleEthAccount(this.ethAccount);
      }
    },

    handleEthAccount(ethAccount) {
      ethereum.request({ method: 'eth_getBalance', params: [ethAccount, 'latest'] }).then(result => {
        this.ethAddress = StringUtil.replacePkh(ethAccount, 4, 38);
        this.ethBalance = NumberUtil.handleEthAmountToFixed(Web3Utils.fromWei(result, 'ether'));

        if (this.active == 'reth' && this.$route.name == 'home') {
          this.$router.push('/reth');
        }
      })
      .catch((error) => {
        this.ethAddress = '';
        this.ethAccount = '';
        Toast({ 
          message: error.message, 
          duration: 3000
        });
      });
    },
    connectPolkadotjs() {
      const injectedPromise = web3Enable('stafi/rtoken');

      injectedPromise
        .then(() => web3Accounts())
        .then((accounts) => {
          if (accounts && accounts.length > 0) {
            LocalStorage.setPolkadotExtensionEnabled();
            this.jumpToFisAccountList();
          } else {
            Toast({ 
              message: 'Please install and enable the Polkadotjs extension, then create or import your account.', 
              duration: 3000 
            });
          }  
        })
        .catch(error => {});
    },

    jumpToFisAccountList() {
      const routeName = this.$route.name;
      if (routeName && routeName != 'fisaccountlist') {
        this.$router.push({ name: 'fisaccountlist', params: {source: routeName}});
      }
    },

    refreshFisBalance() {
      this.handleFisAccount();
    },

    handleFisAccount() {
      let currentAddress = LocalStorage.getCurrentFisAccount();
      if (currentAddress) {
        this.fisAccount = currentAddress;
        this.fisAddress = StringUtil.replacePkh(currentAddress, 4, 44);

        Api.createStafiApi().then(api => {
          api.query.system.account(currentAddress).then(result => {
            if (result) {
              let fisBalance = NumberUtil.fisAmountToHuman(result.data.free);
              this.fisBalance = NumberUtil.handleFisAmountToFixed(fisBalance);
            }
          }).catch((error) => {});
        })
        .catch((error) => {});
      }
    },

    getRequest() {
      let url = window.location.search;
      let theRequest = new Object();
      if (url.indexOf('?') != -1) {
        let str = url.substr(1);
        let strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
      }
      return theRequest;
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      window.localStorage.setItem('lang', lang);
    },
  },
  created() {
    const self = this;
    let height = document.documentElement.scrollHeight;
    if (height > 300) {
      this.scrollerHeight = (height - 10) + 'px';
    }
    const innerWidth = window.innerWidth;
    // 移动端，跳转
    if (innerWidth < 1024) {
      let href = 'https://m.stafi.io';
      let url = window.location.search;
      if (url.indexOf('?') != -1) {
        let str = url.substr(1);
        href += '/?' + str;
      }
      location.href = href;
    } else {
      const url = window.location.search;
      const theRequest = this.getRequest();
      if (theRequest.locale && (theRequest.locale == 'cn' || theRequest.locale == 'en')) {
        this.changeLang(theRequest.locale);
      } else {
        const lang = window.localStorage.getItem('lang');
        if (lang) {
          this.$i18n.locale = lang;
        } else {
          this.$i18n.locale = 'en';
        }
      }
    }

    if (this.active == 'reth') {
      if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
        ethereum.autoRefreshOnNetworkChange = false;
      }

      this.refreshEthBalance();
    } else if (this.active == 'rfis') {
      if (LocalStorage.getCurrentFisAccount()) {
        this.handleFisAccount();
        const routeName = this.$route.name;
        if (routeName == 'home') {
          this.$router.push('/rfis');
        }
      } else {
        if (this.$route.name != 'fishome') {
          this.$router.push('/fishome');
        }
      }
    }

  }
}
</script>

<style lang="scss">
body {
  background-color: #2B3239;
}

.app {
  width: 1280px;
  margin: 0 auto;
  background-color: #23292F;
}

.nav {
  padding: 20px 40px;
  display: flex;

  .logo {
    cursor: pointer;
    height: 29px;
    img {
      height: 100%;
    }
  }

  .nav-right {
    flex: 1;
    text-align: right;
    font-size: 14px;

    .connect-metamask {
      cursor: pointer;
      background-color: #343B43;
      border-radius: 3px;
      color: #CBCBCB;
      font-weight: bold;
      padding: 6px 11px;
    }

    .balance {
      background-color: #343B43;
      border-radius: 3px;
      color: #CBCBCB;
      margin-right: 20px;
      padding: 6px 12px;
    }

    .address {
      cursor: pointer;
      background-color: #343B43;
      border-radius: 3px;
      color: #CBCBCB;
      padding: 6px 12px;
    }
  }
}

.content {
  padding: 40px 30px;
  display: flex;

  .content-left {
    text-align: left;
    margin-right: 180px;

    .menus {
      .menu {
        cursor: pointer;
        padding: 3px 13px;
        margin-bottom: 24px;
        display: flex;
        font-size: 16px;

        .icon {
          margin-right: 10px;
          height: 36px;
          img {
            height: 100%;
          }
        }

        .text {
          height: 36px;
          line-height: 36px;
        }
      }

      .active {
        background-color: #E7FFF8;
        border-radius: 21px;
        color: #00F3AB;
        font-weight: bold;
      }
    }

    .env {
      margin-top: 299px;
      margin-left: 20px;
      display: flex;

      .point {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background-color: #00F3AB;
        margin-top: 5px;
      }

      .text {
        color: #B6B6B6;
        font-size: 14px;
        margin-left: 8px;
      }
      
    }

  }
}


#app {
  font-family: Helvetica, "Avenir", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
</style>
